export default "__VITE_ASSET__BvfoWITK__"